import React from 'react';
import './styles.scss'
import Menu from './Menu/'

const HeaderMobile = ({userdata, sections, logoPosition, hbutton}) => (
    <header className="MobileHeader">
        <div className="HamburgerMenu">
            <Menu userdata={userdata} sections={sections} logoPosition={logoPosition} hbutton={hbutton}/>
        </div>
    </header>
)
 
export default HeaderMobile;